import React from 'react';
type SectionTone = 'ivory' | 'white' | 'ink';
type SectionProps = {
  children: React.ReactNode;
  id?: string;
  tone?: SectionTone;
  divider?: boolean;
  className?: string;
  ariaLabel?: string;
};
const tones: Record<SectionTone, string> = {
  ivory: 'bg-ivory text-ink',
  white: 'bg-white text-ink',
  ink: 'bg-ink text-ivory'
};
export function Section({
  children,
  id,
  tone = 'ivory',
  divider = true,
  className = '',
  ariaLabel
}: SectionProps) {
  return <section id={id} aria-label={ariaLabel} className={`w-full ${tones[tone]} py-16 md:py-24 ${className}`} data-id="element-185" data-mp="herpp8gsn4ox">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-186" data-mp="2qn33teme90v">
        {children}
        {divider && tone !== 'ink' && <div className="rule-gold mt-16 md:mt-24" aria-hidden="true" data-id="element-187" data-mp="7ndlindwdgpg" />}
      </div>
    </section>;
}